import React, { FC } from 'react'

export const PortraitIcon: FC<{ uid: string }> = ({ uid }) => {
  const firstId = `${uid}-first`
  const secondId = `${uid}-second`

  return (
    <svg width="24" height="24" viewBox="0 0 24 24">
      <defs>
        <path id={firstId} d="M0 .047h11.65v4.611H0z" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <rect width="24" height="24" fill="#42C6CD" rx="12" />
        <path
          fill="#FFF"
          d="M11.726 6c-1.246.016-2.478.917-2.755 2.018v.001c-.171.679-.16 1.24.04 1.937.395 1.817 1.515 3.063 2.736 3.063 1.185 0 2.295-1.202 2.703-2.923.201-.665.289-1.254.08-2.077C14.253 6.91 13.005 6.005 11.754 6h-.027z"
        />
        <g transform="translate(6 13.457)">
          <mask id={secondId} fill="#fff">
            <use xlinkHref={`#${firstId}`} />
          </mask>
          <path
            fill="#FFF"
            d="M11.65 4.658V4.39s.02-1.14-.39-2.281c0 0-.252-.592-.823-.886 0 0-2.511-.96-4.588-1.176h-.065C3.707.262 1.19 1.227 1.19 1.227c-.571.294-.833.886-.833.886C-.053 3.254.003 4.39.003 4.39v.268H11.65z"
            mask={`url(#${secondId})`}
          />
        </g>
      </g>
    </svg>
  )
}
